import { createRouter, createWebHistory } from 'vue-router';
import KhouseHome from './components/KhouseHome.vue';
import AboutPage from './components/AboutPage.vue';
import LessonPage from './components/LessonPage.vue';
import LinksPage from './components/LinksPage.vue';
import PostDetail from './components/PostDetail.vue';

const routes = [
  { path: '/', name: 'home', component: KhouseHome },
  { path: '/about', name: 'about', component: AboutPage },
  { path: '/lesson', name: 'lesson', component: LessonPage },
  { path: '/links', name: 'links', component: LinksPage },
  { path: '/post/:slug', name: 'post', component: PostDetail }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          const headerEl = document.querySelector('header');
          const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
          const target = document.querySelector(to.hash);
          if (target) {
            const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          }
          resolve({ left: 0, top: 0 });
        });
      });
    }
    return { left: 0, top: 0 };
  }
});

export default router;


